import { type MembershipTierPlan, MembershipTierPlanFrequency } from '@/models/membershipTierPlan'
import type { MembershipTier } from '@/models/membershipTier'

export function compareTierAndPlan(
  currentTier: MembershipTier,
  newTier: MembershipTier,
  currentPlan: MembershipTierPlan | null | undefined,
  newPlan: MembershipTierPlan | null | undefined,
): number {

  if (newTier.id === currentTier.id && newPlan?.id === currentPlan?.id) {
    // equal no tier change
    return 0
  }

  if (
    !currentTier?.isFixedTier ||
    (currentPlan?.frequency === MembershipTierPlanFrequency.MONTH && newPlan?.frequency === MembershipTierPlanFrequency.YEAR)
  ) {
    // upgrade tier
    return 1
  }

  if (newTier.isFixedTier && newPlan && currentPlan && newPlan.price > currentPlan.price) {
    // upgrade tier
    return 1
  }

  // downgrade tier
  return -1
}